import styled from "styled-components";
import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";

export const ServicesPageBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(8)};
  padding: ${toRem(16)};

  max-height: ${toRem(300)};
  overflow: clip auto;

  a {
    background-color: ${COLORS.NEUTRAL.CONTAINER_SOFT};
    border-radius: ${toRem(16)};
    display: flex;
    align-items: center;
    gap: ${toRem(12)};
    padding: ${toRem(16)};
    transition: background-color 0.3s ease 0s;
    color: var(--fg-soft, rgba(16, 24, 40, 0.75));
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
      
      @media (any-hover: hover){
      &:hover{
        background-color: ${COLORS.BG.PAGE};
      }
    }
  }
`
